// src/admin/components/RequireAdmin.jsx
// Route guard for the entire /admin/* section, mirroring RequireOwner.jsx.
// The API enforces this server-side on every admin endpoint (401 on a
// missing/invalid/revoked token) -- this guard is purely UX, same
// reasoning as RequireOwner: without it, a logged-out visitor hitting
// an admin page directly gets a broken half-rendered page instead of a
// clean redirect to /admin/login.

import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAdmin } from "@/admin/hooks/useAdmin";

export default function RequireAdmin({ children, requireSuperAdmin = false }) {
  const { admin, loading } = useAdmin();

  if (loading) {
    return (
      <section className="grid min-h-screen place-items-center bg-cream">
        <Loader2 className="h-6 w-6 animate-spin text-ink/40" />
      </section>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  if (requireSuperAdmin && admin.role !== "super_admin") {
    // A support_agent hitting a super_admin-only page (e.g. Team & Roles)
    // gets sent to the admin dashboard instead of a 403 page.
    return <Navigate to="/admin/merchants" replace />;
  }

  return children;
}
